import 'react-perfect-scrollbar/dist/css/styles.css';
import React, { useState } from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import GlobalStyles from 'src/components/GlobalStyles';
import 'src/mixins/chartjs';
import theme from 'src/theme';
import { routes, signedOutRoutes } from 'src/routes';
import { firebase } from 'src/db/db';
import { MusicianProvider } from 'src/musicianContext';
import getUserMusician from 'src/utils/getUserMusician';

const App = () => {
  const [signedIn, setSignedIn] = useState(true);
  const [user, setUser] = useState(null);
  const [musician, setMusician] = useState(null);
  const [logo, setLogo] = useState();
  const [displayName, setDisplayName] = useState();
  const [phone, setPhone] = useState();

  firebase.auth().onAuthStateChanged(async user => {
    //Change Routes based on auth status.
    setSignedIn(user ? true : false);
    setUser(user);
    if (user) {
      const musicianData = await getUserMusician(user.uid);
      if (musicianData) {
        setMusician(musicianData.artist);
        setLogo(musicianData.logo);
        setDisplayName(musicianData.displayName);
        setPhone(musicianData.phone);
      }
    }
  });

  const routing = useRoutes(signedIn ? routes : signedOutRoutes);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <MusicianProvider
        value={{
          signedIn: signedIn,
          user: user,
          musician: musician,
          logo: logo ? logo : (user ? user.photoURL: null),
          setLogo: setLogo,
          displayName: displayName,
          phone: phone
        }}
      >
        {routing}
      </MusicianProvider>
    </ThemeProvider>
  );
};

export default App;
